import type { QueryClient } from "@tanstack/react-query"
import { createRouter } from "@tanstack/react-router"

import { queryClient } from "@/lib/query-client"

import {
  appRoute,
  branchesRoute,
  citiesRoute,
  customerDetailRoute,
  customersRoute,
  dashboardRoute,
  hubsRoute,
  loginRoute,
  parcelDetailRoute,
  parcelsRoute,
  paymentsRoute,
  pickupsRoute,
  pricingMatrixRoute,
  riderLocationsRoute,
  riderApplicationsRoute,
  ridersRoute,
  routesRoute,
  rolesRoute,
  serviceAreasRoute,
  serviceZonesRoute,
  settlementsRoute,
  trackingRoute,
  transfersRoute,
  deliveriesRoute,
  deliveryProofsRoute,
  usersRoute,
  vehiclesRoute,
} from "./routes/app-routes"
import { rootRoute } from "./routes/root"

const routeTree = rootRoute.addChildren([
  loginRoute,
  appRoute.addChildren([
    dashboardRoute,
    parcelsRoute,
    parcelDetailRoute,
    trackingRoute,
    branchesRoute,
    hubsRoute,
    usersRoute,
    rolesRoute,
    customersRoute,
    customerDetailRoute,
    paymentsRoute,
    settlementsRoute,
    citiesRoute,
    serviceZonesRoute,
    serviceAreasRoute,
    vehiclesRoute,
    pricingMatrixRoute,
    ridersRoute,
    riderLocationsRoute,
    riderApplicationsRoute,
    pickupsRoute,
    transfersRoute,
    deliveriesRoute,
    deliveryProofsRoute,
    routesRoute,
  ]),
])

/**
 * The route tree is assembled here, by hand.
 *
 * A convention-based file tree would be fine too, but the admin is small and
 * the shapes that matter — one pathless authenticated layout, and a guard on
 * every screen that needs a permission key — are easier to audit in one list
 * than spread across a directory of route files.
 */
export function createAdminRouter(client: QueryClient = queryClient) {
  return createRouter({
    routeTree,
    context: { queryClient: client },
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
  })
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createAdminRouter>
  }
}
